// Phone locality → does the Assign flow need GDMS zero-touch (SN + RPS)?
//
// Since #684 (PnP relay in the SBC), phones on the PBX LAN and phones behind an
// SBC provision via multicast PnP with no serial number. GDMS RPS zero-touch is
// only required when neither applies — a drop-ship / home-worker phone on a
// network with no SBC. The discovered-phone row carries this as sbc_name:
// 'Local (PBX)', a named SBC site, or empty when no site matched the subnet.

export type PhoneLocality = 'local' | 'sbc' | 'unknown';

export const LOCAL_PBX = 'Local (PBX)';

export function classifyLocality(sbcName?: string | null): PhoneLocality {
  const name = String(sbcName ?? '').trim();
  if (!name) return 'unknown';
  return name === LOCAL_PBX ? 'local' : 'sbc';
}

// True only when the phone's network has no PnP path (no PBX LAN, no SBC) —
// the one case where the operator must capture a serial for GDMS RPS.
export function needsGdmsZeroTouch(sbcName?: string | null): boolean {
  return classifyLocality(sbcName) === 'unknown';
}
